import axios from './axios';

const unwrap = (response) => response?.data?.data ?? response?.data ?? response;

export function resolveWorkspace(workspaces, currentWorkspace, preferredWorkspaceId, requestedWorkspaceId) {
  return workspaces.find((workspace) => workspace.id === requestedWorkspaceId)
    || workspaces.find((workspace) => workspace.id === preferredWorkspaceId)
    || workspaces.find((workspace) => workspace.id === currentWorkspace?.id)
    || workspaces[0]
    || currentWorkspace
    || null;
}

export function withInvitedWorkspace(path, search) {
  const workspaceId = new URLSearchParams(search).get('workspaceId');
  return workspaceId ? `${path}?workspaceId=${encodeURIComponent(workspaceId)}` : path;
}

export async function fetchWorkspaces() {
  const response = await axios.get('/api/account/workspaces', {cache: false});
  const workspaces = unwrap(response);
  return Array.isArray(workspaces) ? workspaces : [];
}

export async function fetchWorkspaceCreditState(workspaceId) {
  const result = unwrap(await axios.get('/api/account/workspace-credits', {params: {workspaceId}, cache: false}));
  if (result?.workspaceId !== workspaceId || !result?.credits) throw new Error('Saldo do espaço de trabalho indisponível.');
  return result;
}

export async function createWorkspace(values) {
  const response = await axios.post('/api/account/workspaces', values);
  return unwrap(response);
}

export async function updateWorkspace(workspaceId, values) {
  const response = await axios.patch(`/api/account/workspaces/${encodeURIComponent(workspaceId)}`, values);
  return unwrap(response);
}

export async function fetchWorkspaceAdmins(workspaceId) {
  const response = await axios.get(`/api/account/workspaces/${encodeURIComponent(workspaceId)}/admins`);
  return unwrap(response);
}

export async function inviteWorkspaceAdmin(workspaceId, values) {
  const response = await axios.post(`/api/account/workspaces/${encodeURIComponent(workspaceId)}/admins`, {
    name: values.name.trim(),
    email: values.email.trim().toLowerCase(),
  });
  return unwrap(response);
}

export async function resendWorkspaceAdminInvitation(workspaceId, invitationId) {
  const response = await axios.post(`/api/account/workspaces/${encodeURIComponent(workspaceId)}/admin-invitations/${encodeURIComponent(invitationId)}/resend`);
  return unwrap(response);
}

export async function revokeWorkspaceAdminInvitation(workspaceId, invitationId) {
  const response = await axios.delete(`/api/account/workspaces/${encodeURIComponent(workspaceId)}/admin-invitations/${encodeURIComponent(invitationId)}`);
  return unwrap(response);
}

export async function removeWorkspaceAdmin(workspaceId, userId) {
  const response = await axios.delete(`/api/account/workspaces/${encodeURIComponent(workspaceId)}/admins/${encodeURIComponent(userId)}`);
  return unwrap(response);
}
